/**
 * Official brand files in `src/assets/brand/`, imported here so Vite fingerprints them. Taken from
 * the legacy admin panel: the logo exists as `logo-black.svg` (black lettering, for light
 * surfaces) and `logo-white.svg` (the same file with white lettering, for navy). The sign-in photo
 * is the v3 design's Wanderers photo (DESIGN-V3; usage rights pending confirmation, see
 * docs/prompts/progress.md).
 */
import loginPhotoUrl from '../assets/brand/login-photo.webp';
import logoBlackUrl from '../assets/brand/logo-black.svg';
import logoWhiteUrl from '../assets/brand/logo-white.svg';

/** The logo on navy (the sign-in card). `null` falls back to the text wordmark (`BrandLogo`). */
export const BRAND_LOGO_URL: string | null = logoWhiteUrl;

/** The logo on light surfaces (not used yet: the sidebar still shows the text wordmark). */
export const BRAND_LOGO_DARK_URL: string | null = logoBlackUrl;

/** The photo behind the sign-in brand panel. `null` leaves the dark panel plain. */
export const LOGIN_PHOTO_URL: string | null = loginPhotoUrl;
